/**
 * 이력 점의 **순위 값 읽기** — 「수집이 없는 날」과 「진짜 순위」를 가른다.
 *
 * ## 🚨 `Number(null)` 은 `0` 이고, `0` 은 유한수다
 *
 * `rank` 의 타입은 `number | null` 이라 `Number.isFinite(Number(point.rank))` 로 거르면
 * **`null` 이 「순위 0」으로 통과한다.** 결측 판정은 반드시 이 파일의 함수로 한다:
 *
 * - 차트에 **존재하지 않는 0위 점**이 찍힌다(축이 `reversed`·`min: 1` 이라 눈금 위로 솟는다)
 * - `maxRank` 가 오염된다 — 점이 전부 결측이면 `ranks` 가 `[]` 가 아니라 `[0, 0, …]` 이라
 *   「점이 없으면 10위까지」 폴백이 **안 걸리고** 축 최대가 3 으로 눌린다
 * - 「그릴 점이 둘 이상인가」 판정이 부풀어, 순위가 하나도 없는 이력에도 차트를 그린다
 *   (「스냅샷이 1일치뿐」 안내가 안 나온다)
 *
 * ⚠️ 값을 **`null` 로 돌려주는 것이 계약**이다. `NaN` 을 넣으면 ApexCharts 의 SVG path
 * 파서가 "parser Error" 로 죽는다(`market-rankings-charts` 머리말). `null` 은 선을 끊는다.
 */

/** 순위 한 칸을 읽는다 — 결측(`null`·`undefined`)과 숫자가 아닌 것은 전부 `null` */
export function toRankValue(rank: unknown): number | null {
  if (rank == null || rank === '') return null;
  const value = Number(rank);
  return Number.isFinite(value) ? value : null;
}

/** 순위가 실제로 있는 점의 수 — 「차트를 그릴 만한가」 판정의 분자 */
export function countRankedPoints(
  points: readonly { rank?: unknown }[] | null | undefined
): number {
  if (!Array.isArray(points)) return 0;
  return points.reduce((count, point) => (toRankValue(point?.rank) == null ? count : count + 1), 0);
}
